import Button from 'react-bootstrap/Button' ;

const SortBtn = ({text}) => {
	return <Button variant="light" >{text}</Button> ;
}

export default SortBtn ;